import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import clsx from "clsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import MenuIcon from "@material-ui/icons/Menu";
import AppBar from "@material-ui/core/AppBar";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { makeStyles } from "@material-ui/core/styles";
import {
    IconButton,
    ThemeProvider,
    Toolbar,
    Typography,
} from "@material-ui/core";

import headerStyle, { theme } from "./headerStyle";
import { Creators as HeaderActions } from "../../store/ducks/header";
import { Creators as LoginActions } from "../../store/ducks/login";
import { MESSAGE_TYPES as msg } from "../../utils/js/constants";

const useStyles = makeStyles((theme) => headerStyle(theme));

const Header = ({ toggle, logoutFirebase, header, login, title }) => {
    const classes = useStyles();
    const history = useHistory();
    const { open } = header;
    const { data } = login;

    useEffect(() => {
        if (data?.message === msg.LOGOUT_SUCCESS) {
            history.push("/");
        }
    }, [data, history]);

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root}>
                <CssBaseline />
                <AppBar
                    position="absolute"
                    className={clsx(
                        classes.appBar,
                        !open && classes.appBarShift
                    )}
                >
                    <Toolbar className={classes.toolbar}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={() => toggle()}
                            className={clsx(
                                classes.menuButton,
                                !open && classes.menuButtonHidden
                            )}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography
                            component="h1"
                            variant="h6"
                            color="inherit"
                            noWrap
                            className={classes.title}
                        >
                            {title}
                        </Typography>
                        <IconButton
                            color="inherit"
                            onClick={() => logoutFirebase()}
                        >
                            <ExitToAppIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </div>
        </ThemeProvider>
    );
};

const mapStatetoProps = (state) => ({ ...state });
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ ...HeaderActions, ...LoginActions }, dispatch);
};

export default connect(mapStatetoProps, mapDispatchToProps)(Header);
